module.exports = __webpack_public_path__ + "img/map-satellite.ebbe3ef2.png";